import React from 'react';
import Loadable from 'react-loadable';
import { LoadingSpinner } from './components';

function Loading() {
  return <LoadingSpinner />;
}

const Page404 = Loadable({
  loader: () => import('./pages/Page404'),
  loading: Loading,
});

const Register = Loadable({
  loader: () => import('./pages/register-1/register-1'),
  loading: Loading,
});

const RegisterNew = Loadable({
  loader: () => import('./pages/register-1/register-new'),
  loading: Loading,
});

const TermCondition = Loadable({
  loader: () => import('./pages/term-condition/term-condition1'),
  loading: Loading,
});

// const TermCondition1 = Loadable({
//   loader: () => import('./pages/term-condition/term-condition1'),
//   loading: Loading,
// });

const EnterPin = Loadable({
  loader: () => import('./pages/pin/enter-pin1'),
  loading: Loading,
});

// const EnterPin1 = Loadable({
//   loader: () => import('./pages/pin/enter-pin1'),
//   loading: Loading,
// });

const OpsiOTP = Loadable({
  loader: () => import('./pages/opsi-otp/opsi-otp'),
  loading: Loading,
});

const EnterOTP = Loadable({
  loader: () => import('./pages/otp/otp'),
  loading: Loading,
});

const routes = [
  // { path: '/', exact: true, name: 'register', component: Register },
  { path: '/', exact: true, name: 'register', component: RegisterNew },
  // { path: '/term-condition', name: 'term-condition', component: TermCondition },
  { path: '/term-condition', name: 'term-condition1', component: TermCondition },
  { path: '/pin', name: 'pin', component: EnterPin },
  // { path: '/pin1', name: 'pin', component: EnterPin1 },
  { path: '/opsi-otp', name: 'opsi-otp', component: OpsiOTP },
  { path: '/otp', name: 'otp', component: EnterOTP },
  { name: '/Page404', component: Page404 },
];

export default routes;
